<template>
  <div class="position-relative" id="subheader">
    <b-container>
      <b-row align-v="center" no-gutters>
        <b-col v-if="false" cols="auto" lg="9" xl="auto" class="position-static">
          <nav  class="main-nav d-none d-md-inline-block">
            <ul class="main-nav-list list-unstyled">
              <li class="main-nav-item">
                <div class="main-nav-link-wrapper">
                  <a target="_blank" :href="`https://www.tuev-nord.de/${lang}/`" class="main-nav-link">
                    TÜV NORD Stationen
                  </a>
                </div>
              </li>
              <li class="main-nav-item">
                <div class="main-nav-link-wrapper">
                  <a target="_blank" :href="`https://www.tuev-nord.de/${lang}/dienstleistungen/`" class="main-nav-link">
                    Dienstleistungen
                  </a>
                  <ul>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/dienstleistungen/`" target="_blank">
                        Übersicht
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/dienstleistungen/pruefung-und-gutachten/`" target="_blank">
                        Prüfung und Gutachten
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/dienstleistungen/fuehrerschein-und-fahrzeug/`" target="_blank">
                        Führerschein und Fahrzeug
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/dienstleistungen/berufliche-weiterbildung/`" target="_blank">
                        Berufliche Weiterbildung
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/dienstleistungen/auditierung-und-zertifizierung/`" target="_blank">
                        Auditierung und Zertifizierung
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/dienstleistungen/beratung/`" target="_blank">
                        Beratung
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="main-nav-item">
                <div class="main-nav-link-wrapper">
                  <a target="_blank" :href="`https://www.tuev-nord.de/${lang}/branche/`" class="main-nav-link">
                    Branchen
                  </a>
                  <ul class="branche-menu-grid">
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/`" target="_blank">
                        Übersicht
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/bahnindustrie/`" target="_blank">
                        Bahnindustrie
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/baugewerbe-bautechnik-und-bauphysik/`" target="_blank">
                        Baugewerbe, Bautechnik und Bauphysik
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/chemie-und-prozessindustrie/`" target="_blank">
                        Chemie- und Prozessindustrie
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/energiewirtschaft-und-versorgung/`" target="_blank">
                        Energiewirtschaft und Versorgung
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/erneuerbare-energien/`" target="_blank">
                        Erneuerbare Energien
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/finanzen-und-versicherungen/`" target="_blank">
                        Finanzen und Versicherungen
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/gesundheitswesen/`" target="_blank">
                        Gesundheitswesen
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/hotellerie-und-gastronomie/`" target="_blank">
                        Hotellerie und Gastronomie
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/immobilien/`" target="_blank">
                        Immobilien
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/informationstechnologie/`" target="_blank">
                        Informationstechnologie
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/kaelte-klima-lueftungstechnik/`" target="_blank">
                        Kälte, Klima, Lüftungstechnik
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/kerntechnik-und-strahlenschutz/`" target="_blank">
                        Kerntechnik und Strahlenschutz
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/konsumgueter-und-handel/`" target="_blank">
                        Konsumgüter und Handel
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/kosmetikhersteller/`" target="_blank">
                        Kosmetikhersteller
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/krankenhaeuser-kliniken-und-pflegeeinrichtungen/`" target="_blank">
                        Krankenhäuser, Kliniken und Pflegeeinrichtungen
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/lebensmittel-und-futtermittel/`" target="_blank">
                        Lebensmittel und Futtermittel
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/luft-und-raumfahrtindustrie/`" target="_blank">
                        Luft und Raumfahrtindustrie
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/medizintechnik/`" target="_blank">
                        Medizintechnik
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/metall-und-elektroindustrie/`" target="_blank">
                        Metall- und Elektroindustrie
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/mobilitaet-automotive/`" target="_blank">
                        Mobilität &amp; Automotive
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/oeffentliche-verwaltung/`" target="_blank">
                        Öffentliche Verwaltung
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/personalwesen/`" target="_blank">
                        Personalwesen
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/pharmazie/`" target="_blank">
                        Pharmazie
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/produzierende-industrie/`" target="_blank">
                        Produzierende Industrie
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/rechenzentren/`" target="_blank">
                        Rechenzentren
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/rohstoffindustrie/`" target="_blank">
                        Rohstoffindustrie
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/schifffahrt/`" target="_blank">
                        Schifffahrt
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/transport-und-logistik/`" target="_blank">
                        Transport und Logistik
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/unternehmensberatung-und-management/`" target="_blank">
                        Unternehmensberatung und Management
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/verpackungsindustrie/`" target="_blank">
                        Verpackungsindustrie
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/branche/versorgung-und-entsorgung/`" target="_blank">
                        Versorgung und Entsorgung
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="main-nav-item">
                <div class="main-nav-link-wrapper">
                  <a target="_blank" :href="`https://www.tuev-nord.de/${lang}/themen/`" class="main-nav-link">
                    Themen
                  </a>
                  <ul class="branche-menu-grid">
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/`" target="_blank">
                        Übersicht
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/betriebliches-gesundheitsmanagement/`" target="_blank">
                        Betriebliches Gesundheitsmanagement
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/cyber-security/`" target="_blank">
                        Cyber-Security
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/datenschutz/`" target="_blank">
                        Datenschutz
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/digitalisierung-und-innovation/`" target="_blank">
                        Digitalisierung und Innovation
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/druckgeraetesicherheit/`" target="_blank">
                        Druckgerätesicherheit
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/elektromobilitaet/`" target="_blank">
                        Elektromobilität
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/elektrotechnik/`" target="_blank">
                        Elektrotechnik
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/energieeffizienz/`" target="_blank">
                        Energieeffizienz
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/funktionale-sicherheit/`" target="_blank">
                        Funktionale Sicherheit
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/halbleiter/`" target="_blank">
                        Halbleiter
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/hygiene/`" target="_blank">
                        Hygiene
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/immissionsschutz/`" target="_blank">
                        Immissionsschutz
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/industrie-40/`" target="_blank">
                        Industrie 4.0
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/informationssicherheit/`" target="_blank">
                        Informationssicherheit
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/klimawandel/`" target="_blank">
                        Klimawandel
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/krisen-und-risikomanagement/`" target="_blank">
                        Krisen- und Risikomanagement
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/kuenstliche-intelligenz/`" target="_blank">
                        Künstliche Intelligenz
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/nachhaltigkeit-und-umweltschutz/`" target="_blank">
                        Nachhaltigkeit und Umweltschutz
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/new-work/`" target="_blank">
                        New Work
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/personalentwicklung/`" target="_blank">
                        Personalentwicklung
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/produktpruefung/`" target="_blank">
                        Produktprüfung
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/projektmanagement/`" target="_blank">
                        Projektmanagement
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/smart-home/`" target="_blank">
                        Smart Home
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/stadtentwicklung/`" target="_blank">
                        Stadtentwicklung
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/supply-chain-management/`" target="_blank">
                        Supply Chain Management
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/verkehrswende/`" target="_blank">
                        Verkehrswende
                      </a>
                    </li>
                    <li>
                      <a :href="`https://www.tuev-nord.de/${lang}/themen/wasserstoff/`" target="_blank">
                        Wasserstoff
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <!-- <li class="main-nav-item d-none d-lg-inline-block">
                <div class="main-nav-link-wrapper">
                  <router-link
                    tabindex="0"
                    to="/"
                    class="btn btn-primary d-none d-lg-block m-0 ml-half text-white fw-bold main-nav-link-btn"
                    aria-current="page"
                  >
                    {{ translations[14997] }}
                  </router-link>
                  <ul>
                    <li><a :href="`https://www.tuev-nord.de/${lang}/Job-Talent-Space/Auf-einen-Blick.php`" target="_blank">{{ translations[15401] }}</a></li>
                    <li><a :href="`https://www.tuev-nord.de/${lang}/Job-Talent-Space/FAQ.php`" target="_blank">FAQ</a></li>
                  </ul>
                </div>
              </li> -->
              <li class="main-nav-item">
                <div class="main-nav-link-wrapper">
                  <a target="_blank" :href="`https://jobmatch.works/${lang}/wissen/`" class="main-nav-link">
                    Wissen
                  </a>
                </div>
              </li>
               <li class="main-nav-item">
                <div class="main-nav-link-wrapper">
                  <a target="_blank" :href="`https://www.tuev-nord.de/${lang}/kontakt-service/kontakt/`" class="main-nav-link">
                    Kontakt
                  </a>
                </div>
              </li>

            </ul>
          </nav>
        </b-col>
        <b-col cols="auto" class="d-flex align-items-center">
          <!-- Logo -->
          <a target="_blank" :href="`https://www.tuev-nord.de/${lang}/dienstleistungen/tuev-nord-transfer/`" class="d-block ml-2">
            <div class="pb-1 pb-sm-3 h-100  text-primary">
              <img :src="require('@/assets/img/logo/logo-ragtp.svg')" alt="talenpool" class="img img-fluid logo-header text-primary" />
            </div>
          </a>
          <!-- /Logo -->
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import LanguageHeader from '@/components/Header/LanguageHeader.vue';
import { AppModule } from '@/store/modules/app';

@Component({
  components: {
    LanguageHeader,
  },
})
export default class HeaderInformationNavigation extends Vue {
  get translations() {
    return AppModule.translation;
  }

  get lang() {
    return 'de';// AppModule.language;
  }
}
</script>
<style scoped lang="scss">
[theme="default"] {
  #subheader {
    background-color: white !important;
  }
  .logo-header {
    max-width: 150px;
    @media (min-width: 786px) {
      max-width: 200px;
    }
    @media (min-width: 1400px) {
      max-width: 230px;
    }
  }
  .main-nav-item {
    margin: 0 3px 0 0;
    ul li a {
      font-size: 16px;
    }
  }
  .main-nav-link {
    color: #68726A;
    font-weight: 500;
    background-color: #EEF1F0;
    padding: 5px 15px;
    margin: 5px 0;
    border-radius: 5px;
    transition: none;
    font-size: 14px;
    @media (min-width: 1280px) {
      font-size: 15px;
    }
    &:hover, &:active {
      background-color: var(--portal-primary);
      color: #ffffff!important;
    }
  }
  .main-nav-link-btn {
    font-weight: 500;
    padding: 5px 15px;
    margin: 5px 0;
    font-size: 14px;
    @media (min-width: 1280px) {
      font-size: 15px;
    }
  }
  .auth-cabinet .logo-header {
    height: auto;
  }
}

.main-nav-list {
  background: #ffffff;
  padding: 0;
  margin: 0;
}
.main-nav-link-wrapper {
  >a, >a:visited, >a:active, >a:hover {
    color: rgb(var(--portal-secondary-600));
    text-decoration: none;
  }
}

//sub-nav
ul.main-nav-list li:hover div > ul {
  visibility: visible;
  opacity: 1;
}
ul.main-nav-list ul {
  list-style: none;
  margin: 5px 0 0;
  padding: 10px 0 0;
  visibility: hidden;
  position: absolute;
  z-index: 99999;
  opacity: 0;
  -webkit-transition: opacity 0.2s linear, visibility 0.2s linear;
  -moz-transition: opacity 0.2s linear, visibility 0.2s linear;
  -o-transition: opacity 0.2s linear, visibility 0.2s linear;
  transition: opacity 0.2s linear, visibility 0.2s linear;
  top: 100%;
  left: 0px;
  text-transform: none;
  font-weight: 600;
  line-height: 1.4em;
  -moz-box-shadow: 2px 5px 8px rgba(0, 0, 0, 0.2);
  box-shadow: 2px 5px 8px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  width: 250px;
  overflow: hidden;
  background: var(--portal-primary);
  &.branche-menu-grid {
    width: auto;
    min-width: 250px;
    @media (min-width: 768px) {
      min-width: 750px;
    }
  }
}

ul.main-nav-list ul li {
  clear: both;
  width: 100%;
  background: none transparent;
}
ul.main-nav-list ul li {
  display: inline;
  float: left;
  margin: 0;
  padding: 0;
  position: relative;
  background-image: none;
  border-radius: 5px;
  margin-right: 2px;
}
ul.main-nav-list ul li a {
  padding: 3px 10px 3px 12px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  display: block;
  border: 0 none;
  clear: both;
  border-radius: 0px;
  background-color: transparent;
}
ul.main-nav-list ul li a:hover,
ul.main-nav-list ul li.active a {
  color: white;
}
ul.main-nav-list ul li:last-child a {
  padding: 3px 10px 12px 12px;
}

ul.branche-menu-grid {
  display: grid;
  grid-template-columns: 1fr;
  width: auto;
  min-width: 250px;
  align-items: start;
  align-content: start;
  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
    min-width: 750px;
    gap: 0;
    align-items: start;
    align-content: start;
  }
  li {
    float: none;
    display: block;
    width: 100%;
    margin-right: 0;
  }
}
</style>
